import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { useResponsiveDialog } from "../../../../../Context/ResponsiveDialogContext";
import { getValidationRules, isFieldRequired } from "../PreLoan";


export default function StepLegalRep() {
    const { control, formState: { errors } } = useFormContext();
    const { containerWidth } = useResponsiveDialog();

    const isSmall = containerWidth > 0 && containerWidth < 500;
    const stepKey = 'legalRep'; // Definir el stepKey para este componente

    return (
        <div className="p-fluid">
            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-6'}`}>
                    <label>Nombre{isFieldRequired('legalRep.nombre', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="legalRep.nombre" control={control} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.legalRep?.nombre && <small className="p-error">{errors.legalRep.nombre.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label> Fecha de Nacimiento{isFieldRequired('legalRep.fechaNacimiento', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="legalRep.fechaNacimiento" control={control} rules={getValidationRules('legalRep.fechaNacimiento', stepKey)} render={({ field }) => (
                        <Calendar
                            name={field.name}
                            value={field.value}
                            onChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            className="w-full"
                            dateFormat="yy-mm-dd"
                            showIcon
                            style={{
                                borderRadius: '17px',
                                overflow: 'hidden',
                                padding: '0',
                                width: '300px',
                                // height: '47px',
                                '& input': {
                                    padding: '0.5rem 1rem',
                                    borderRadius: '0px',
                                }
                            }} panelStyle={{
                                borderRadius: '17px'
                            }} />
                    )} />
                    {errors.legalRep?.fechaNacimiento && <small className="p-error">{errors.legalRep.fechaNacimiento.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Enti. de Nacimiento{isFieldRequired('legalRep.entidadNacimiento', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="legalRep.entidadNacimiento" control={control} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.legalRep?.entidadNacimiento && <small className="p-error">{errors.legalRep.entidadNacimiento.message}</small>}
                </div>
            </div>
            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Identificación{isFieldRequired('legalRep.identificacion', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="legalRep.identificacion" control={control} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.legalRep?.identificacion && <small className="p-error">{errors.legalRep.identificacion.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Clave de elector{isFieldRequired('legalRep.claveElector', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="legalRep.claveElector" control={control} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.legalRep?.claveElector && <small className="p-error">{errors.legalRep.claveElector.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Emisión{isFieldRequired('legalRep.emision', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="legalRep.emision" control={control} render={({ field }) => (
                        <Calendar
                            name={field.name}
                            value={field.value}
                            onChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            style={{
                                borderRadius: '17px',
                                overflow: 'hidden',
                                padding: '0',
                                width: '300px',
                                // height: '47px',
                                '& input': {
                                    padding: '0.5rem 1rem',
                                    borderRadius: '0px',
                                }
                            }} panelStyle={{
                                borderRadius: '17px'
                            }} className="w-full" dateFormat="yy-mm-dd" showIcon />
                    )} />
                    {errors.legalRep?.emision && <small className="p-error">{errors.legalRep.emision.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Vigencia{isFieldRequired('legalRep.vigencia', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="legalRep.vigencia" control={control} render={({ field }) => (
                        <Calendar
                            name={field.name}
                            value={field.value}
                            onChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            style={{
                                borderRadius: '17px',
                                overflow: 'hidden',
                                padding: '0',
                                width: '300px',
                                // height: '47px',
                                '& input': {
                                    padding: '0.5rem 1rem',
                                    borderRadius: '0px',
                                }
                            }} panelStyle={{
                                borderRadius: '17px'
                            }} className="w-full" dateFormat="yy-mm-dd" showIcon />
                    )} />
                    {errors.legalRep?.vigencia && <small className="p-error">{errors.legalRep.vigencia.message}</small>}
                </div>
            </div>
            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>OCR{isFieldRequired('legalRep.ocr', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="legalRep.ocr" control={control} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.legalRep?.ocr && <small className="p-error">{errors.legalRep.ocr.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>Vencimiento{isFieldRequired('legalRep.vencimiento', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="legalRep.vencimiento" control={control} render={({ field }) => (
                        <Calendar
                            name={field.name}
                            value={field.value}
                            onChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            style={{
                                borderRadius: '17px',
                                overflow: 'hidden',
                                padding: '0',
                                width: '300px',
                                // height: '47px',
                                '& input': {
                                    padding: '0.5rem 1rem',
                                    borderRadius: '0px',
                                }
                            }} panelStyle={{
                                borderRadius: '17px'
                            }} className="w-full" dateFormat="yy-mm-dd" showIcon />
                    )} />
                    {errors.legalRep?.vencimiento && <small className="p-error">{errors.legalRep.vencimiento.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>NSS{isFieldRequired('legalRep.nss', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="legalRep.nss" control={control} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.legalRep?.nss && <small className="p-error">{errors.legalRep.nss.message}</small>}
                </div>
            </div>
        </div>
    );
}


